module.exports = __webpack_public_path__ + "img/logo.252b967e.png";